import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import { ROUTES } from 'config/routes';
import BrandLoader from '../Loaders/BrandLoader';
import { useMinimumLoading } from '../../../hooks/useMinimumLoading';


interface AuthGuardProps {
  children: React.ReactNode;
  redirectTo?: string;
}

const AuthGuard: React.FC<AuthGuardProps> = ({
  children,
  redirectTo = ROUTES.LOGIN,
}) => {
  const { isAuthenticated, isLoading, userRole } = useAuth();
  const showLoader = useMinimumLoading(isLoading && !userRole, 2000);
  const location = useLocation();


  if (showLoader) {
    return <BrandLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default AuthGuard;